<div class="tile-head flex-row flex-vertical-center">
  <cigna-icon class="dashboard-icon" type="news"></cigna-icon>
  <h3 class="cg-h3">{{ 'dashboard.latestUpdateTile.header' | translate }}</h3>
</div>

<ng-container *ngIf="isLoading">
  <div class="cg-flex-center cg-margin-top-lg cg-margin-bottom-lg">
    <div class="cg-spinner"></div>
  </div>
</ng-container>

<section *ngIf="shouldShowNewFeatures && features.length">
  <div class="tile-section">
    <cigna-new-features [features]="features"></cigna-new-features>
  </div>
</section>

<section *ngIf="updates.length" class="updates-list">
  <div
    class="tile-section"
    *ngFor="
      let update of updates | slice: 0:(!isExpanded ? defaultLength : 999)
    "
  >
    <cigna-latest-update-item [update]="update"></cigna-latest-update-item>
  </div>
  <ng-container *ngIf="updates?.length > defaultLength && !isExpanded">
    <button cignaButton="link" (click)="showMore()">
      {{ 'dashboard.latestUpdateTile.showMore' | translate }}
    </button>
  </ng-container>
</section>

<ng-container *ngIf="updates?.length === 0 && isLoading === false">
  <div class="tile-section">No updates available</div>
</ng-container>
